import { PermissionCode } from '@core-frontend/core-frontend';
import { lazy } from 'react';

import { AppRoutes } from '../AppRoutes';
import type { RouteProtectedWithPermissionObject } from '../types';

const RolesPage = lazy(() =>
  import('@/pages/role').then((module) => ({ default: module.RolesPage }))
);

const RoleDetailViewPage = lazy(() =>
  import('@/pages/role').then((module) => ({
    default: module.RoleDetailViewPage,
  }))
);

export const roleRouter: RouteProtectedWithPermissionObject[] = [
  {
    path: AppRoutes.ROLES,
    element: <RolesPage />,
    permissions: [PermissionCode.VIEW_ROLES],
  },
  {
    path: AppRoutes.ROLE_DETAILS,
    element: <RoleDetailViewPage />,
    permissions: [
      PermissionCode.VIEW_ROLES,
      PermissionCode.ADD_ROLES,
      PermissionCode.UPDATE_ROLES,
      PermissionCode.VIEW_ROLE_PERMISSIONS,
      PermissionCode.ADD_ROLE_PERMISSIONS,
      PermissionCode.UPDATE_ROLE_PERMISSIONS,
    ],
  },
];
